'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _uniq2 = require('lodash/uniq');

var _uniq3 = _interopRequireDefault(_uniq2);

var _compact2 = require('lodash/compact');

var _compact3 = _interopRequireDefault(_compact2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _responseCodes = require('helpers/responseCodes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./RecipientsImportsErrors.scss');

var RecipientsImportsErrors = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(RecipientsImportsErrors, _PureComponent);

  function RecipientsImportsErrors() {
    (0, _classCallCheck3.default)(this, RecipientsImportsErrors);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientsImportsErrors.__proto__ || (0, _getPrototypeOf2.default)(RecipientsImportsErrors)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientsImportsErrors, [{
    key: 'getErrorMessage',
    value: function getErrorMessage() {
      var _errors;

      var t = this.context.t;
      var _props = this.props,
          data = _props.data,
          message = _props.message;

      var existError = t('Some email addresses already exist');
      var invalidError = t('Some contacts are invalid');

      var errors = (_errors = {}, (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.invalidContact, invalidError), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.recipientExists, existError), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.emailExists, existError), (0, _defineProperty3.default)(_errors, _responseCodes.importRecipientsCodes.groupEmailExists, existError), _errors);
      var messages = [_react2.default.createElement(
        'p',
        { key: 'msg', className: styles.message },
        message
      )];

      data.map(function (recipient) {
        if (errors[recipient.result]) {
          messages[recipient.result] = _react2.default.createElement(
            'div',
            { key: recipient.result, className: 'error' },
            errors[recipient.result]
          );
        }
      });

      return (0, _compact3.default)((0, _uniq3.default)(messages));
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;


      return _react2.default.createElement(
        'div',
        { className: className },
        this.getErrorMessage()
      );
    }
  }]);
  return RecipientsImportsErrors;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  data: _propTypes2.default.array,
  message: _propTypes2.default.string
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  data: []
}, _temp);
exports.default = RecipientsImportsErrors;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RecipientsImportsErrors/RecipientsImportsErrors.js
// module id = 2093
// module chunks = 1